import React from "react";
import { Wrapper } from "../shared/Wrapper";
import { CardNews } from "~/features/article";
import { Grid, GridItem } from "styled-system/jsx";
import { INews } from "~/features/article/@types";
import { EmptyState } from "./EmptyState";

interface TipsProps {
  datum: INews[];
}

export const Tips: React.FC<TipsProps> = ({ datum }) => {
  return (
    <Wrapper
      title="Kiat Kiat dari Ecobiz"
      subTitle="Kumpulan tips untuk menerapkan praktik bisnis yang berkelanjutan dan ramah lingkungan"
      to="/article/community"
    >
      {datum.length === 0 ? (
        <EmptyState />
      ) : (
        <Grid
          gridTemplateColumns={{
            base: "1",
            sm: "2",
            lg: "3",
          }}
          mt={6}
        >
          {datum.map((v) => (
            <GridItem gridColumn="1" key={v.id}>
              <CardNews datum={v} hash="Kiat-kiat" />
            </GridItem>
          ))}
        </Grid>
      )}
    </Wrapper>
  );
};
